import { useQuery, useMutation } from "react-query";
import { secureAxios } from "../_helpers/auth";
import log from "cslog";

export const useUploadFile = (onSuccess) => {
    return useMutation(
        (formData) => {
            return secureAxios.post(`/files`, formData).then((res) => res.data);
        },
        {
            onSuccess: onSuccess,
        }
    );
};

export const useDeleteFile = (onSuccess)=> {
    return useMutation(
        (id) => {
            return secureAxios.delete(`/files/${id}`).then((res) => res.data);
        },
        {
            onSuccess: onSuccess,
        }
    );
};
export const useRestoreFile = (onSuccess) => {
  return useMutation({
    mutationFn: async (id) => {
      const response = await secureAxios.patch(`/files/${id}`, {
        archived: false,
      });
      return response.data;
    },
    onSuccess,
  });
};

export const useSoftDeleteFile = (onSuccess) => {
  return useMutation({
    mutationFn: (id) =>
      secureAxios.patch(`/files/${id}`, { archived: true }).then((res) => res.data),
    onSuccess,
  });
};

export const useHardDeleteFile = (onSuccess) => {
  return useMutation({
    mutationFn: (id) =>
      secureAxios.delete(`/files/${id}`).then((res) => res.data),
    onSuccess,
  });
};

